import React from 'react';
import { Controls } from './components/Controls/Controls';
import { DashboardSettings } from './components/DashboardSettings/DashboardSettings';
import { SessionData } from './components/SessionData/SessionData';
import { SessionTabs } from './components/SessionTabs/SessionTabs';
import { FirstRow, SecondRow, TopBarWrapper } from './styles/MetricsTopBarStyles';

interface IProps {}

export const MetricsTopBar: React.FC<IProps> = (props) => {
  return (
    <TopBarWrapper>
      <FirstRow>
        <Controls />
        <SessionData />
      </FirstRow>
      <SecondRow>
        <SessionTabs />
        <DashboardSettings />
      </SecondRow>
    </TopBarWrapper>
  );
};
